module.exports = __webpack_public_path__ + "static/media/Bayswater Ave Burlingame, CA1.0bf108ae.jpg";